import { GridValidRowModel } from "@mui/x-data-grid-pro";

export const mockSurgeryRows: GridValidRowModel[] = [
    {
        id: 1,
        surgeryName: "Apse Temizliği",
        plannedDate: "22.05.2025 14:15"
    }
];